import axios from "axios";
import { safeParse } from "./utility"

let baseURL = "https://api.dbstaffaccount.com"
if (process.env.NODE_ENV && process.env.NODE_ENV === 'development') {
    baseURL = null
}

const API = axios.create({
    withCredentials: true,
    baseURL
});



API.interceptors.request.use((config) => {
    const token = safeParse("staffAT");
    const businessId = safeParse("businessId");
    const staffId = safeParse("staffId");

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers["x-business-id"] = businessId || "";
        config.headers["x-staff-id"] = staffId || "";
    }
    return config;
});


export default API;